function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m173.933 260.349c43.512 12.195 74.688 46.546 86.6 84.725 11.41-9.101 25.37-20.421 40.77-33.322l-94.52-94.525c-12.75 16.311-23.92 31.082-32.85 43.122z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m451.653.355c-72.596 7.632-180.444 136.611-226.09 193.23l98.67 98.675c55.549-47.902 183.79-162.522 187.67-235.343 1.884-34.962-25.352-60.239-60.25-56.562z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m52.465 326.937c-43.706 54.633-7.118 103.387-48.345 146.857-7.179 7.569-4.618 20.004 4.98 24.113 68.277 29.23 154.26 10.25 194.109-31.767 37.467-39.505 49.058-107.533 3.602-152.992-43.809-43.813-117.297-32.52-154.346 13.789z"
});

var SvgPaintBrush = function SvgPaintBrush(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaintBrush, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paint-brush.06aac420.svg";
export { ForwardRef as ReactComponent };